// Navigation : burger mobile, sous-menus (survol, clic, clavier), accordéon mobile.
const DESKTOP = "(min-width: 1241px)";

export default function nav() {
    const nav = document.getElementById("nav-primary");
    if (!nav) return;

    const burger = document.getElementById("burger");
    const items = [...nav.querySelectorAll(".nav-item")].filter((li) => li.querySelector(":scope > .nav-toggle"));
    const desktop = matchMedia(DESKTOP);

    function ouvrir(li, etat) {
        const b = li.querySelector(":scope > .nav-toggle");
        b.setAttribute("aria-expanded", String(etat));
    }

    function toutFermer(sauf) {
        items.forEach((li) => { if (li !== sauf) ouvrir(li, false); });
    }

    items.forEach((li) => {
        const b = li.querySelector(":scope > .nav-toggle");
        let minuterie;

        b.addEventListener("click", () => {
            const etat = b.getAttribute("aria-expanded") !== "true";
            if (desktop.matches) toutFermer(li);
            ouvrir(li, etat);
        });

        // Survol (desktop seulement), avec une courte tolérance de sortie
        li.addEventListener("mouseenter", () => {
            if (!desktop.matches) return;
            clearTimeout(minuterie);
            toutFermer(li);
            ouvrir(li, true);
        });
        li.addEventListener("mouseleave", () => {
            if (!desktop.matches) return;
            minuterie = setTimeout(() => ouvrir(li, false), 160);
        });

        // Perte de focus vers l'extérieur de l'élément
        li.addEventListener("focusout", (e) => {
            if (desktop.matches && !li.contains(e.relatedTarget)) ouvrir(li, false);
        });

        // Échap referme et rend le focus au chevron
        li.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && b.getAttribute("aria-expanded") === "true") {
                e.preventDefault();
                ouvrir(li, false);
                b.focus();
            }
        });
    });

    document.addEventListener("click", (e) => {
        if (!nav.contains(e.target) && !(burger && burger.contains(e.target))) toutFermer();
    });

    if (burger) {
        burger.addEventListener("click", () => {
            const ouvert = nav.dataset.open !== "true";
            nav.dataset.open = String(ouvert);
            burger.setAttribute("aria-expanded", String(ouvert));
            burger.setAttribute("aria-label", ouvert ? "Fermer le menu" : "Menu");
        });

        nav.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && nav.dataset.open === "true") {
                nav.dataset.open = "false";
                burger.setAttribute("aria-expanded", "false");
                burger.focus();
            }
        });
    }

    // Changement de mode d'affichage : on repart propre
    desktop.addEventListener("change", () => {
        toutFermer();
        if (burger) { nav.dataset.open = "false"; burger.setAttribute("aria-expanded", "false"); }
    });
}
